import EmblaCarousel from 'embla-carousel';

(function (Drupal) {
  Drupal.behaviors.emblaCarousel = {
    attach(context) {
      const carousels = once('embla-carousel-init', '.embla', context);

      carousels.forEach((carousel) => {
        const viewport = carousel.querySelector('.embla__viewport');
        const prevBtn = carousel.querySelector('.embla__prev');
        const nextBtn = carousel.querySelector('.embla__next');

        const embla = EmblaCarousel(viewport, {
          loop: false,
          slidesToScroll: 1,
          align: 'center'
        });

        if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
        if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());
      });
    }
  };
})(Drupal);
